export default "__VITE_ASSET__O1uK57bC__"